var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _path4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiw5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 174,
    viewBox: "0 0 280 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 279,
    height: 173,
    rx: 12.5,
    fill: "white",
    stroke: "#2B2BCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.999 58.9996C49.354 59.0846 57.984 49.1996 57.899 38.5096C57.8165 27.8246 49.354 19.0846 38.999 18.9996C28.644 18.9146 20.3165 27.5096 20.399 38.1996C20.4865 48.8846 28.6465 58.9096 38.999 58.9996Z",
    fill: "#DFFC6B",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7498 36.5C47.7271 34.5179 46.9296 32.6235 45.528 31.2218C44.1263 29.8202 42.2319 29.0227 40.2498 29M38.9998 64.875C39.8023 64.875 40.2048 64.875 40.4823 64.82C42.1173 64.5 43.1098 62.89 42.6273 61.345C42.5448 61.0825 42.3548 60.74 41.9748 60.0575M38.9998 64.875C38.1973 64.875 37.7948 64.875 37.5173 64.82C35.8823 64.5 34.8898 62.89 35.3723 61.345C35.4548 61.0825 35.6448 60.74 36.0248 60.0575M38.9998 64.875V70.25",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 36,
    width: 165,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 53,
    width: 103,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 126,
    width: 103,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.999 138C49.354 138.085 57.984 128.2 57.899 117.51C57.8165 106.825 49.354 98.0846 38.999 97.9996C28.644 97.9146 20.3165 106.51 20.399 117.2C20.4865 127.885 28.6465 137.91 38.999 138Z",
    fill: "#EFF660",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7498 115.5C47.7271 113.518 46.9296 111.623 45.528 110.222C44.1263 108.82 42.2319 108.023 40.2498 108M38.9998 143.875C39.8023 143.875 40.2048 143.875 40.4823 143.82C42.1173 143.5 43.1098 141.89 42.6273 140.345C42.5448 140.082 42.3548 139.74 41.9748 139.058M38.9998 143.875C38.1973 143.875 37.7948 143.875 37.5173 143.82C35.8823 143.5 34.8898 141.89 35.3723 140.345C35.4548 140.082 35.6448 139.74 36.0248 139.058M38.9998 143.875V149.25",
    stroke: "#2B2BCB",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 109,
    width: 165,
    height: 11,
    fill: "#2B2BCB",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiw5);
export default __webpack_public_path__ + "static/media/HIW-5.2649565db9bd1377f9964b07d140ba40.svg";
export { ForwardRef as ReactComponent };